import { Outlet } from '@remix-run/react';

import { DashboardLayout } from 'platform/DashboardLayout';

export default function ExternalDashboardLayoutRoute(): RouteComponentOutput {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
